<template>
    <div>
        <el-form :model="suit" ref="suitInfo">
            <div class="content-caption dashed">
                <span>基本信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>套装系统编号</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.no}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>套装名称</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.name}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>所属机构</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.retailerShopName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>机构标签</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.retailerShopTagName || '无'}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>套内资产数量</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.devcQuantity}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>最新套装变更时间</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.ts}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>主资产信息</span>
            </div>
            <div class="simple-form">
                <div class="form-group center" v-if="suit.imageUrl != null && suit.imageUrl != ''">
                    <div class="form-label">
                        <label>资产图片</label>
                    </div>
                    <div class="form-value">
                        <img :src="suit.imageUrl" style="width: 100px;">
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>资产描述全称</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.devcTitle}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>系统编号</label>
                    </div>
                    <div class="form-value">
                        <a class="swb-btn-link" @click.stop="gotoShopDevice(suit.devcTmpNo)">{{suit.devcTmpNo}}</a>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>分类</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.devcCatName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>分类分组</label>
                    </div>
                    <div class="form-value">
                        <span>{{getDevcGroupNameByCatId(suit.devcCatId)}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>品牌</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.devcBrandName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>规格</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.devcModelSpec}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任部门</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.departName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>责任人</label>
                    </div>
                    <div class="form-value">
                        <span>{{suit.principalName}}</span>
                    </div>
                </div>
                <div class="form-group center">
                    <div class="form-label">
                        <label>备注</label>
                    </div>
                    <div class="form-value width-2x">
                        <span>{{suit.memo}}</span>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>附属资产信息</span>
            </div>
            <div class="table-layout">
                <el-table :data="suit.shopDeviceSuitAccList" border style="width: 100%">
                    <el-table-column align="left" width="100" label="图片">
                        <template slot-scope="rows">
                            <img :src="rows.row.imageUrl" v-if="rows.row.imageUrl != null && rows.row.imageUrl!=''">
                        </template>
                    </el-table-column>
                    <el-table-column prop="devcTitle" label="名称" align="left" width="150" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcTmpNo" label="系统编号" width="250" align="left" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span><a class="swb-btn-link" @click.stop="gotoShopDevice(rows.row.devcTmpNo)">{{rows.row.devcTmpNo}}</a></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="devcCatName" label="分类" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcGroup" label="分类分组" align="left" min-width="130" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{getDevcGroupNameByCatId(rows.row.devcCatId)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="devcBrandName" label="品牌" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="devcModelSpec" label="规格" width="150" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="departName" label="责任部门" width="100" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="principalName" label="责任人" width="100" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="memo" label="备注"></el-table-column>
                </el-table>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDevcGroupNameByCatId } from '../index'

    import shopDevcApi from '../../api/shopDevc';
    import devcApi from '../../api/devc'

    export default {
        name: 'swb-shop-device-suit-detail',
        props: {
            id: {
                type: Number,
                deafult: null,
            },
            toShopDeviceList: {
                type: Function
            }
        },
        data: function () {
            return {
                suit: {}
            }
        },
        created: function () {
            this.getSuitById();
        },
        methods: {
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            gotoShopDevice: function (tmpNo) {
                this.toShopDeviceList.call(parent, tmpNo);
            },
            getSuitById(){
                let self = this;
                let theLoading = MsgBox.loading();
                devcApi.getShopDeviceSuitById(this.id, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.suit = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceSuitDetail.vue